import * as React from 'react';
import * as _ from 'lodash';
import axios from 'axios';
import { Formik, FieldArray } from 'formik';
import { toast } from 'react-toastify';

export default class LesImagesUpload extends React.Component<any, any> {
  private URL = process.env.REACT_APP_IMAGES_URL;
  private BUCKET_PREFIX = process.env.REACT_APP_IMAGES_PREFIX || '';

  constructor(props: any) {
    super(props);

    this.state = {
      bucket: this.BUCKET_PREFIX + 'images-main',
      tags: '',
      images: [],
    };

    this.uploadFiles = this.uploadFiles.bind(this);
    this.saveImages = this.saveImages.bind(this);
  }

  public componentWillMount() {
    this.setState({ images: [] });
  }

  public render() {
    return (
      <div>
        <input
          className="form-control"
          type="file"
          onChange={(e) => {
            if (e.target.files) {
              const files: FileList = e.target.files;
              this.uploadFiles(files);
            }
          }}
          multiple={true}
        />
        <hr/>
        <Formik
          initialValues={{ images: this.state.images }}
          enableReinitialize={true}
          onSubmit={
            async (values: any, { setSubmitting, setErrors }: any) => {
              try {
                await this.saveImages(values);
              } catch (err) {
                console.log(err);
              }
            }
          }
          render={({ values, handleChange, handleSubmit }: any) => {
            return (
              <form
                onSubmit={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleSubmit();
                }}
                autoComplete="off"
              >
                <FieldArray
                  name="images"
                  render={(arrayHelpers) => {
                    return (
                      values.images.map((image: any, index: number) => {
                        return (
                          <div className="row" key={index}>
                            <div className="col-md-3">
                              <img src={image.url} style={{ height: '100px', width: '100%' }} />
                            </div>
                            <div className="col-md-9">
                              <div className="form-group">
                                <label>Tags</label>
                                <input
                                  className="form-control"
                                  type="text"
                                  name={`images.${index}.tags`}
                                  onChange={handleChange}
                                  value={image.tags}
                                  required={true}
                                />
                              </div>
                              <div className="form-group">
                                <label>Bucket</label>
                                <select
                                  className="form-control"
                                  name={`images.${index}.bucket`}
                                  onChange={handleChange}
                                  value={image.bucket}
                                >
                                <option value={this.BUCKET_PREFIX + "images-main"}>Principal</option>
                                <option value={this.BUCKET_PREFIX + "images-misc"}>Miscelaneo</option>
                                <option value={this.BUCKET_PREFIX + "images-activities"}>Actividades</option>
                                <option value={this.BUCKET_PREFIX + "images-destinations"}>Destinos</option>
                                <option value={this.BUCKET_PREFIX + "images-hotels"}>Hoteles</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    );
                  }}
                />

                <div className="form-group text-right">
                  <button type="submit" className="btn btn-lg btn-dark" disabled={!values.images.length}>
                    SUBIR IMAGENES
                  </button>
                </div>
              </form>
            );
          }}
        >
        </Formik>
      </div>
    );
  }

  private async uploadFiles(files: FileList) {
    let i = 0;

    while (i < files.length) { /* tslint:disable-line */
      const form = new FormData();
      form.append('file', files[i], files[i].name);

      const { data } = await axios({
        method: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data',
          jwt: localStorage.getItem('token'),
        },
        url: `${this.URL}/api/images/upload`,
        data: form,
      });

      const image: any = {
        filename: data.filename,
        url: `${this.URL}/tmp/${data.filename}`,
        bucket: this.BUCKET_PREFIX + 'images-main',
        tags: '',
      };

      this.setState({ images: this.state.images.concat([image])});
      i += 1;
    }
  }

  private async saveImages(formData: any): Promise<any> {
    const body = formData.images.map((image: any) => {
      const copy = _.cloneDeep(image);
      copy.tags = copy.tags.split(',');

      return copy;
    });

    const response = await axios({
      data: body,
      method: 'POST',
      url: `${this.URL}/api/images`,
      headers: {
        jwt: localStorage.getItem('token'),
      },
    });

    toast.success('Las imagenes fueron guardadas');
    this.props.onUploadFinished(response.data);
  }
}



// WEBPACK FOOTER //
// ./src/containers/Shared/Images/upload.tsx